"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("mktDashboardService", function ($http, $modal) {
  return {
    getDetteIndexes: function getDetteIndexes() {
      return $http.get("/rest/market/dashboard/dette-indexes").then(function (response) {
        return response.data;
      });
    },
    getFavoriteIndexations: function getFavoriteIndexations() {
      return $http.get("/rest/market/dashboard/favorites/list").then(function (response) {
        return response.data;
      });
    },
    openFavoriteCreationPopin: function openFavoriteCreationPopin() {
      return $modal.open({
        controller: "mktDashboardCreateFavoritePopinCtrl",
        template: require("./mkt-dashboad-create-favorite-popin.html")
      });
    },
    createFavorite: function createFavorite(valorisableRef) {
      return $http.post("/rest/market/dashboard/favorites/add", valorisableRef).then(function (response) {
        return response.data;
      });
    },
    deleteFavorite: function deleteFavorite(favoriteId) {
      var params = {
        id: favoriteId
      };
      return $http.get("/rest/market/dashboard/favorites/delete", {
        params: params
      }).then(function (response) {
        return response.data;
      });
    },
    switchFavoritePositions: function switchFavoritePositions(firstId, secondId) {
      var params = {
        firstId: firstId,
        secondId: secondId
      };
      return $http.get("/rest/market/dashboard/favorites/switch-position", {
        params: params
      }).then(function (response) {
        return response.data;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/dashboard/mktDashboardService.js
// module id = 2843
// module chunks = 13